import {ErrorHandler, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavController, ToastController} from '@ionic/angular';
import {ERROR_OUTPUT, LOG_OUTPUT} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class ErrorService implements ErrorHandler {
    
    constructor(private router: Router,
                private toastCtrl: ToastController,
                private navCtrl: NavController,
                public sanatize: DomSanitizer) {
    }
    
    public handleError(error: any, origin?: string) {
        
        this.consoleError('ErrorService:handleError', 'origin: ' + origin, error);
        
        if (error.status === 403) {
            this.redirectLogin();
        } else if (error.status === 405 && error.error.includes('No cycles exists for this userid')) {
            this.router.navigate(['/tabs']);
        } else if (error.status === 400) {
            this.consoleError('ErrorService:handleError', '400: ', error);
            const errorMsg = error.error.error || error.error.result;
            this.presentToastConfirm(errorMsg);
        } else if (error.status === 500) {
            this.consoleError('ErrorService:handleError', '500: ', error);
            const errorMsg = error.statusText + ' (' + error.status + ')';
            this.presentToastConfirm(errorMsg);
        }
    }
    
    redirectLogin() {
        // this.router.navigate(['/login']);
        // this.router.navigateByUrl('/login');
        this.navCtrl.navigateRoot('/login');
    }
    
    async presentToast(msg: string, pos = 'middle', dur: number = 2000) {
        const options: any = {
            message: msg,
            position: pos,
            duration: dur
        };
        const toast = await this.toastCtrl.create(options);
        
        await toast.present();
    }
    
    async presentToastConfirm(msg: string, pos = 'middle') {
        const options: any = {
            message: msg,
            position: pos,
            buttons: ['OK']
        };
        const toast = await this.toastCtrl.create(options);
        
        await toast.present();
    }
    
    public consoleLog(origin: string, msg: string, obj: any = {}) {
        if (LOG_OUTPUT) {
            console.group(origin);
            console.log(msg, obj);
            console.groupEnd();
        }
    }
    
    public consoleError(origin: string, msg: string, obj: any = {}) {
        if (ERROR_OUTPUT) {
            console.group(origin);
            console.error(msg, obj);
            console.groupEnd();
        }
    }
}
